import { Button } from '@ordo/ui/button'
import { usePwa } from 'hooks/usePwa'
import { CloudOff, Wifi, WifiOff } from 'lucide-react'

export function PwaPrompt() {
  const { offlineReady, mutationQueued, mutationsSynced, dismissOfflineReady } = usePwa()

  if (!offlineReady && !mutationQueued && !mutationsSynced) {
    return null
  }

  return (
    // On phones it sits above the floating search circle and the home indicator
    // instead of covering them. No "new version" notice: updates apply on their own.
    <div className="fixed inset-x-4 bottom-[calc(env(safe-area-inset-bottom,0px)+5.5rem)] z-50 flex flex-col gap-2 md:inset-x-auto md:right-4 md:bottom-4">
      {offlineReady && (
        <div className="flex items-center gap-3 rounded-xl bg-background/90 p-4 shadow-md backdrop-blur-sm">
          <WifiOff className="h-5 w-5 shrink-0 text-muted-foreground" />
          <span className="flex-1 text-sm">App ready for offline use</span>
          <Button variant="ghost" size="sm" onClick={dismissOfflineReady}>
            Dismiss
          </Button>
        </div>
      )}

      {mutationQueued && (
        <div className="flex items-center gap-3 rounded-xl bg-background/90 p-4 shadow-md backdrop-blur-sm">
          <CloudOff className="h-5 w-5 shrink-0 text-amber-500" />
          <span className="flex-1 text-sm">You're offline — changes will sync when reconnected</span>
        </div>
      )}

      {mutationsSynced && (
        <div className="flex items-center gap-3 rounded-xl bg-background/90 p-4 shadow-md backdrop-blur-sm">
          <Wifi className="h-5 w-5 shrink-0 text-green-500" />
          <span className="flex-1 text-sm">Offline changes have been synced</span>
        </div>
      )}
    </div>
  )
}
